export default __webpack_public_path__ + "static/media/me_active.346c3780.svg";